import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['container', 'input'];
  copyInput() {
    const container = this.containerTarget;
    this.inputTargets.forEach((input)=>{
      const targetInput = container.querySelector(input.dataset.target);
      if (targetInput) {
        targetInput.value = input.value;
        targetInput.dispatchEvent(new Event("input", { bubbles: true }));
      }
    })
  }
}
